// Typed, versioned bridge between the web client and the native iOS shell.
//   JS → native:  webkit.messageHandlers.starweave.postMessage(msg)
//   native → JS:  native calls window.__starweaveReceive(JSON string)
// Degrades gracefully to console logging in a plain browser (no WKWebView).

export interface BridgeMessage {
  v: 1;
  type: string;
  [k: string]: unknown;
}

interface WebkitBridge {
  messageHandlers?: { starweave?: { postMessage(msg: unknown): void } };
}

const webkit = (window as unknown as { webkit?: WebkitBridge }).webkit;

export function bridgeAvailable(): boolean {
  return !!webkit?.messageHandlers?.starweave;
}

export function sendToNative(msg: { type: string; [k: string]: unknown }): void {
  const full: BridgeMessage = { ...msg, v: 1 };
  if (webkit?.messageHandlers?.starweave) {
    webkit.messageHandlers.starweave.postMessage(full);
  } else {
    console.log('[bridge→native]', full);
  }
}

type Receiver = (msg: BridgeMessage) => void;
let receiver: Receiver = () => {};

export function onNativeMessage(fn: Receiver): void {
  receiver = fn;
}

(window as unknown as { __starweaveReceive?: (json: string) => void }).__starweaveReceive = (
  json: string,
) => {
  try {
    receiver(JSON.parse(json) as BridgeMessage);
  } catch (e) {
    console.error('[bridge] bad message from native', e);
  }
};
